import type { Analytics } from 'firebase/analytics';
import { getAnalytics, isSupported } from 'firebase/analytics';
import type { FirebaseApp } from 'firebase/app';
import { initializeApp } from 'firebase/app';

export const firebaseConfig = {
    apiKey: "AIzaSyDVJc4DnuitsnCiUIQhSKtn8dRUqApaO0c",
    authDomain: "penticton-dev-meetup.firebaseapp.com",
    projectId: "penticton-dev-meetup",
    storageBucket: "penticton-dev-meetup.firebasestorage.app",
    messagingSenderId: "123606706454",
    appId: "1:123606706454:web:0ec7c18b54621396c28837",
    measurementId: "G-G5KDWGS8VF"
} as const;

let firebaseAppInstance: FirebaseApp | undefined;
let analyticsInstance: Promise<Analytics | null> | undefined;

export const getFirebaseApp = (): FirebaseApp => {
  if (!firebaseAppInstance) {
    firebaseAppInstance = initializeApp(firebaseConfig);
  }

  return firebaseAppInstance;
};

export const getFirebaseAnalytics = async (): Promise<Analytics | null> => {
  if (!analyticsInstance) {
    analyticsInstance = isSupported().then(supported =>
      supported ? getAnalytics(getFirebaseApp()) : null
    );
  }

  return analyticsInstance;
};
